import React, { useEffect } from 'react';
import { Box, IconButton, TextField, Typography } from '@material-ui/core';
import { SortIcon } from '../../icons';
import AutocompleteSelect from './AutocompleteSelect';
import { MODAL_TYPE } from '../../hooks/useModal';
import { useModals } from '../../hooks/useModal';

const SortableAutocomplete = ({
    droppableId = 'droppable',
    values = [],
    initCall,
    autocompleteCall,
    setFieldValue,
    label
}) => {
    const { showModal } = useModals();
    const [items, setItems] = React.useState([]);

    useEffect(() => {
        const init = async () => {
            const res = await initCall(values || []);
            setItems(res);
        };
        init();
    }, [initCall, values]);

    return (
        <Box>
            <Box style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <Typography variant="caption" style={{ fontSize: '0.70rem' }} color="textSecondary">
                    {label}
                </Typography>
                <IconButton
                    size="small"
                    disabled={values.length < 2}
                    onClick={() => {
                        showModal(MODAL_TYPE.DRAG_DROP, {
                            title: 'Sort items',
                            props: {
                                droppableId,
                                values,
                                items,
                                setItems,
                                setFieldValue
                            }
                        });
                    }}
                    title="Sort items"
                >
                    <SortIcon />
                </IconButton>
            </Box>
            <AutocompleteSelect
                initCall={initCall}
                autocompleteCall={autocompleteCall}
                value={values}
                setValue={newValue => {
                    setFieldValue(newValue);
                }}
                multiple
            >
                <TextField />
            </AutocompleteSelect>
        </Box>
    );
};

export default SortableAutocomplete;
